import { IAuthResponse } from "../redux/features/auth/IAuthState";

export interface Courier {
    id: string;
    name: string;
    trackingUrl: string;
    exactTrackingUrl: string;
    email: string;
    phone: string;
    website: string;
    status: number;
    createdAt: string;
    updatedAt: string;
    deletedAt: string | null;
    shipmentType: number;
    modeOfTransport: number;
    courierBoundary: number;
    courierCode: number;
    ratingApi: string;
    fullUrl: string;
}

export interface PriceRating {
    id: string;
    serviceName: string;
    serviceCode: string;
    modeOfTransport: number;
    notes: string;
    status: number;
    createdAt: string;
    updatedAt: string;
    deletedAt: string;
    courier: Courier;
    totalCharge: number;
    currency: string;
}

export interface DeleteCourier extends IAuthResponse {
    id: string;
}

export enum CourierStatus {
    Active = 1,
    Inactive = 2,
}

export enum ModeOfTransport {
    Air = 1,
    Ground = 2,
    Ocean = 3
}

export const ModeOfTransportOptions = [{
    id: ModeOfTransport.Air,
    name: "Air"
}, {
    id: ModeOfTransport.Ground,
    name: "Ground"
}, {
    id: ModeOfTransport.Ocean,
    name: "Ocean"
}]

export const CourierBoundaryType = {
    International: 1,
    Domestic: 2,
    InternationalAndDomestic: 3
}

export const ShippingCostType = {
    Manual: false,
    Automatic: true
}